export default __webpack_public_path__ + "static/media/comingSoonClock.4e8c4ddf.svg";